export const LOGGED_IN = 'LOGGED_IN'
export const LOGGED_OUT = 'LOGGED_OUT'

export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js